const { calculateEtldPlusOne } = require('./utils');
var containerIdsByETldPlusOne = {
    'autoscout24.de': 'GTM-MK57H2',
    'autoscout24.at': 'GTM-WBZ87G',
    'autoscout24.be': 'GTM-5BWB2M',
    'autoscout24.lu': 'GTM-NDBDCZ',
    'autoscout24.es': 'GTM-PS6QHN',
    'autoscout24.fr': 'GTM-PD93LD',
    'autoscout24.it': 'GTM-WTCSNR',
    'autoscout24.nl': 'GTM-TW48BJ',
    'autoscout24.com': 'GTM-KWX9NX',
    'gebrauchtwagen.at': 'GTM-KPJB2BN',
    'autotrader.nl': 'GTM-5J7WWB3',
    'autotrader.ca': 'GTM-TTQ59MMB',
    'autohebdo.net': 'GTM-TTQ59MMB',
    'autotrack.nl': 'GTM-WRHCNB',
};

var isIdentityPage = function (hostname) {
    return hostname === 'accounts.autoscout24.com';
};

var extractTldFromRedirectUrl = function (url) {
    // search for ui_locales=xx in URL
    var regexp = new RegExp(/ui_locales=([a-z]+)/g);
    var matches = window.location.href.match(regexp);
    var locale = 'com';

    if (matches) {
        var match = matches.join(''); // i.e. ui_locales=de
        locale = match.split('=')[1];
    }

    // Map locale to eTLD+1 format
    // Since this is for identity pages (accounts.autoscout24.com), 
    // we assume it's autoscout24 with the appropriate TLD
    var localeToTldMap = {
        'de': 'autoscout24.de',
        'at': 'autoscout24.at',
        'be': 'autoscout24.be',
        'lu': 'autoscout24.lu',
        'es': 'autoscout24.es',
        'fr': 'autoscout24.fr',
        'it': 'autoscout24.it',
        'nl': 'autoscout24.nl',
        'com': 'autoscout24.com'
    };

    return localeToTldMap[locale] || 'autoscout24.com';
};

module.exports = function (hostname) {
    var tld = isIdentityPage(hostname) ? extractTldFromRedirectUrl(window.location.href) : calculateEtldPlusOne(hostname);
    return containerIdsByETldPlusOne[tld] || containerIdsByETldPlusOne['autoscout24.com'];
};



// WEBPACK FOOTER //
// ./src/gtm/getGtmContainerId.js